/** Same-origin app paths only. Blocks protocol-relative and external redirects. */
export function safeAppPath(raw: string | null | undefined): string {
  if (!raw) return "/hub";
  const path = raw.trim();
  if (!path.startsWith("/")) return "/hub";
  if (path.startsWith("//") || path.includes("://")) return "/hub";
  return path;
}

/** Guest CTA: open the Hub signup gate, then continue to the intended page. */
export function signupHrefFor(dest: string): string {
  const next = safeAppPath(dest);
  if (next === "/hub") return "/hub?signup=1";
  return `/hub?signup=1&next=${encodeURIComponent(next)}`;
}
